import axios,{AxiosInstance} from 'axios'
import auth from './Auth'
import ElementUI from 'element-ui'
import config from '@/config'

const service = axios.create({
  baseURL: config.baseUrl // api的base_url
  // timeout: 5000 // request timeout
})


// 请求拦截器
service.interceptors.request.use(request => {
  // 如果存在token,附加到到请求头
  auth.appendToken(request.headers)
  return request
}, error => {
  ElementUI.Message.error(error.message)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
  // 如果存在token,提取到本地localStorage
  if (response.status === 200) {
    auth.pickToken(response.headers)
  }
  return response
}, error => {
  ElementUI.Message.error(error.message)
  if (error.response && error.response.status === 401) {
    auth.clearToken();
    location.href = '/scm'
  }
})

export default service
